import { createContext } from 'react';

export const PowerSearchHighlightContext = createContext<string>('');
PowerSearchHighlightContext.displayName = 'PowerSearchHighlightContext';
